<template>
  <div class="personal-container">
    <el-card>
      <el-form :scroll-to-error="true" ref="formRefs" :model="form" label-width="120px" label-position="top" v-if="mounted && pageConfig.fields && pageConfig.fields.length > 0">
        <el-row :gutter="20">
        <template v-for="it in pageConfig.fields" :key="it.id">
          <el-col :span="24" v-if="it.id === 'IDImg' || it.id === 'VisaImg'">
            <el-form-item
              :label="it.title"
              :prop="it.id"
              :rules="[
                {
                  required: it.mandatory,
                  message: $t(`registration.form.required`, it),
                },
              ]"
            >
              <div style="width: 100%">
                <UploadFile v-model="form[it.id]" />
              </div>

              <div v-if="it.remark" style="color: #777; font-size: 12px; line-height: 18px; padding-top: 3px">
                {{ it.remark }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="it.remark && !(it.id === 'Gender' && genderList.length > 1||it.id === 'Title' && titleList.length > 1) ? 24 : 12" v-else-if="it.id === 'Mobile'">
            <el-form-item
              :label="it.title"
              :prop="it.id"
              :rules="[
                {
                  required: it.mandatory,
                  message: $t(`registration.form.required`, it),
                },
                {
                  validator: phoneValidator,
                },
              ]"
            >
              <el-input v-suggest-off v-model="form[it.id]" />
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="it.remark && !(it.id === 'Gender' && genderList.length > 1||it.id === 'Title' && titleList.length > 1) ? 24 : 12" v-else-if="it.id === 'MicroBlog'">
            <el-form-item
              :label="it.title"
              :prop="it.id"
              :rules="[
                {
                  required: it.mandatory,
                  message: $t(`registration.form.required`, it),
                },
                {
                  validator: taxNoValidator,
                },
              ]"
            >
              <el-input v-suggest-off v-model="form[it.id]" />
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="it.remark && !(it.id === 'Gender' && genderList.length > 1||it.id === 'Title' && titleList.length > 1) ? 24 : 12" v-else>
            <el-form-item
              :label="it.title"
              :prop="it.id"
              :rules="[
                {
                  required: it.mandatory,
                  message: $t(`registration.form.required`, it),
                },
              ]"
            >
              <template v-if="it.id === 'Gender'">
                <el-select v-suggest-off v-model="form[it.id]" style="width: 100%">
                  <template v-if="genderList && genderList.length">
                    <el-option v-for="it in genderList" :label="it" :value="it"></el-option>
                  </template>
                  <tempate v-else>
                    <template v-if="$event.Language === 1">
                      <el-option value="Dr." label="博士"></el-option>
                      <el-option value="Mr." label="先生"></el-option>
                      <el-option value="Mrs." label="女士"></el-option>
                      <el-option value="Ms." label="小姐"></el-option>
                    </template>
                    <template v-else>
                      <el-option value="Dr." label="Dr."></el-option>
                      <el-option value="Mr." label="Mr."></el-option>
                      <el-option value="Mrs." label="Mrs."></el-option>
                      <el-option value="Ms." label="Ms."></el-option>
                    </template>
                  </tempate>
                </el-select>
              </template>

              <template v-else-if="it.id === 'Title'&&titleList && titleList.length">
                <el-select v-suggest-off v-model="form[it.id]" style="width: 100%">
                  <el-option v-for="it in titleList" :label="it" :value="it"></el-option>
                </el-select>
              </template>

              <template v-else-if="it.id === 'ExpDate' || it.id === 'Birthday' || it.id == 'DateIssue'">
                <el-date-picker v-model="form[it.id]" type="date" placeholder="" value-format="YYYY-MM-DD" format="YYYY-MM-DD" />
              </template>

              <template v-else-if="it.id === 'Country'">
                <el-select v-suggest-off clearable v-model="form[it.id]" style="width: 100%" filterable @change="handleAreaChange(form)">
                  <el-option v-for="it in Area.countries" :key="it.ID" :label="it.Title[locale]" :value="it.Title[locale]"></el-option>
                </el-select>
              </template>
              <template v-else-if="it.id === 'State'">
                <el-select v-suggest-off clearable v-if="form.Country && Area.states.length" v-model="form.State" style="width: 100%" filterable @change="handleAreaChange(form)">
                  <el-option v-for="it in Area.states" :key="it.ID" :label="it.Title[locale]" :value="it.Title[locale]"></el-option>
                </el-select>
                <el-input v-suggest-off v-else v-model="form.State" placeholder=""></el-input>
              </template>
              <template v-else-if="it.id === 'City'">
                <el-select v-suggest-off clearable v-if="form.Country && form.State && Area.cities.length" v-model="form.City" style="width: 100%" filterable @change="handleAreaChange(form)">
                  <el-option v-for="it in Area.cities" :key="it.ID" :label="it.Title[locale]" :value="it.Title[locale]"></el-option>
                </el-select>
                <el-input v-suggest-off v-else v-model="form.City" placeholder=""></el-input>
              </template>

              <template v-else-if="it.id === 'District'">
                <el-select v-suggest-off clearable v-if="form.Country && form.State && form.City && Area.districts.length" v-model="form.District" style="width: 100%" filterable>
                  <el-option v-for="it in Area.districts" :key="it.ID" :label="it.Title[locale]" :value="it.Title[locale]"></el-option>
                </el-select>

                <el-input v-suggest-off v-else v-model="form.District" placeholder=""></el-input>
              </template>

              <template v-else>
                <el-input v-suggest-off v-model="form[it.id]" />
              </template>

              <div v-if="!(it.id === 'Gender' && genderList.length > 1||it.id === 'Title' && titleList.length > 1) && it.remark" style="color: #777; font-size: 12px; line-height: 18px; padding-top: 3px">
                {{ it.remark }}
              </div>
            </el-form-item>
          </el-col>
        </template>
      </el-row>

        <el-form-item label="" class="center" style="margin-bottom: 0">
          <el-button type="primary" @click="handleSubmit">{{ $t('registration.btn.ok') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
  import { ElMessage, ElLoading } from 'element-plus'

  import { onMounted, ref, inject, reactive, computed } from 'vue'

  import { personal } from '@/api/registration'
  import { getArea } from '@/api/common'
  import { useAppStore } from '@/store/modules/app'
  import { useI18n } from 'vue-i18n'
  import { getInformation } from '@/api/registration'
  import { getPageConfig, getSteps } from '@/api/config'

  import UploadImage from '@/components/UploadImage'
  import UploadFile from '@/components/UploadFile'

  const { t, te } = useI18n()

  const { area } = useAppStore()

  const $event = inject('$event')
  const $steps = inject('$steps')
  const $area = ref([])
  const Area = reactive({
    countries: [],
    states: [],
    cities: [],
    districts: [],
  })

  const locale = computed(() => {
    if ($event.Language == 2) return 1
    return 0
  })

  const pageConfig = ref({ fields: [] })
  const form = ref({})
  const formRefs = ref(null)
  const mounted = ref(false)

  const handleAreaChange = ({ Country, State, City }) => {
    if (Country) {
      Area.states = (area.find((x) => x.Title[0] === Country || x.Title[1] === Country || x.Title[2] === Country) || { children: [] }).children || []
      console.log('handleAreaChange', Area.states)
      Area.cities = []
      Area.districts = []
      if (State) {
        Area.cities = (Area.states.find((x) => x.Title[0] === State || x.Title[1] === State || x.Title[2] === State) || { children: [] }).children || []
        if (City) {
          Area.districts = (Area.cities.find((x) => x.Title[0] === City || x.Title[1] === City || x.Title[2] === City) || { children: [] }).children || []
        }
      }
    }
  }

  onMounted(async () => {
    mounted.value = false
    const { data } = await getPageConfig('personal')
    pageConfig.value = data
    const { data: z } = await getInformation()
    form.value = z.data

    Area.countries = area.map((x) => {
      return {
        ID: x.ID,
        Title: x.Title,
      }
    })
    handleAreaChange(form.value)

    //

    mounted.value = true
  })

  const handleSubmit = () => {
    formRefs.value.validate(async (valid, fields) => {
      if (!valid) {
        for (var g in fields) {
          ElMessage({
            message: fields[g][0].message + '',
            type: 'error',
          })
          break
        }
        return
      }
      const loadingInstance = ElLoading.service({ fullscreen: true })
      try {
        const { data } = await personal(form.value)
        ElMessage({ message: t('registration.form.Success'), type: 'success' })
      } catch (e) {
        //ElMessage({ message: e.msg, type: 'error' })
      }
      loadingInstance.close()
    })
  }

  const genderList = computed(() => {
    for (var it of pageConfig.value.fields) {
      if (it.id === 'Gender' && it.remark) {
        return it.remark.split(';').filter((x) => x)
      }
    }
    return []
  })

  const titleList = computed(() => {
    for (var it of pageConfig.value.fields) {
      if (it.id === 'Title' && it.remark) {
        return it.remark.split(';').filter((x) => x)
      }
    }
    return []
  })

  const phoneValidator = (rule, value, callback) => {
    var regex = /^1\d{10}$/
    if(rule.required){
      if(!value){
        callback(new Error(t('registration.form.phone-validator')))
        return
      }
    }
    if (value&&!regex.test(value)) {
      callback(new Error(t('registration.form.phone-validator')))
    } else {
      callback()
    }
  }
  const taxNoValidator = (rule, value, callback) => {
    if (!value) {
      callback()
      return
    }
    if (value.length != 18) {
      callback(new Error(t('registration.form.taxno-validator')))
      return
    }

    callback()
  }
</script>

<style lang="scss" scoped>
  .personal-container {
    margin: 0;
    overflow-y: auto;
    max-height: 100%;
    padding: 20px;
  }
  .el-card {
    background: #ffffff;
    box-shadow: 0px 0px 16px rgba(54, 63, 94, 0.08);
    border-radius: 8px;
    border-width: 0;
    margin: 0;
    max-width: 960px;
    margin: 0 auto;
  }
  .el-form-item {
    &.center {
      :deep() {
        .el-form-item__content {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
</style>
